import React from 'react';
import CandidateForm from '../../components/HR/CandidateForm';
import type { Job, Application } from './types';

interface CandidateFormModalProps {
  editingApplication: Application | null;
  selectedJobForApply: Job | null;
  jobs: Job[];
  onSubmit: (data: any) => Promise<void>;
  onCancel: () => void;
}

const CandidateFormModal: React.FC<CandidateFormModalProps> = ({
  editingApplication, selectedJobForApply, jobs, onSubmit, onCancel,
}) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto py-8">
    <div className="relative w-full max-w-6xl mx-4">
      <div className="max-h-[90vh] overflow-y-auto">
        <CandidateForm
          candidate={editingApplication ? {
            id: editingApplication.id,
            firstName: editingApplication.candidateName.split(' ')[0] || '',
            lastName: editingApplication.candidateName.split(' ').slice(1).join(' ') || '',
            email: editingApplication.email,
            phone: editingApplication.phone,
            nationality: '',
            dateOfBirth: '',
            appliedPosition: jobs.find(j => j.id === editingApplication.jobId)?.title || '',
            source: 'website',
            experience: 0,
            education: '',
            certificates: [],
            languages: [],
            previousCompany: '',
            expectedSalary: 0,
            availableFrom: '',
            coverLetter: '',
            status: editingApplication.status as any,
            assignedManagerId: '',
            assignedManagerName: '',
            managerFeedback: '',
            notes: editingApplication.notes || '',
            rating: editingApplication.rating,
            totalRating: editingApplication.totalRating,
            appliedDate: editingApplication.appliedDate,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
          } : undefined}
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      </div>
    </div>
  </div>
);

export default CandidateFormModal;
